/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdatePalReauthEmrDocumentSelection200ResponseData } from './UpdatePalReauthEmrDocumentSelection200ResponseData';
import {
    UpdatePalReauthEmrDocumentSelection200ResponseDataFromJSON,
    UpdatePalReauthEmrDocumentSelection200ResponseDataFromJSONTyped,
    UpdatePalReauthEmrDocumentSelection200ResponseDataToJSON,
    UpdatePalReauthEmrDocumentSelection200ResponseDataToJSONTyped,
} from './UpdatePalReauthEmrDocumentSelection200ResponseData';

/**
 * 
 * @export
 * @interface UpdatePalReauthEmrDocumentSelection200Response
 */
export interface UpdatePalReauthEmrDocumentSelection200Response {
    /**
     * 
     */
    data?: UpdatePalReauthEmrDocumentSelection200ResponseData;
}

/**
 * Check if a given object implements the UpdatePalReauthEmrDocumentSelection200Response interface.
 */
export function instanceOfUpdatePalReauthEmrDocumentSelection200Response(value: object): value is UpdatePalReauthEmrDocumentSelection200Response {
    return true;
}

export function UpdatePalReauthEmrDocumentSelection200ResponseFromJSON(json: any): UpdatePalReauthEmrDocumentSelection200Response {
    return UpdatePalReauthEmrDocumentSelection200ResponseFromJSONTyped(json, false);
}

export function UpdatePalReauthEmrDocumentSelection200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalReauthEmrDocumentSelection200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : UpdatePalReauthEmrDocumentSelection200ResponseDataFromJSON(json['data']),
    };
}

export function UpdatePalReauthEmrDocumentSelection200ResponseToJSON(json: any): UpdatePalReauthEmrDocumentSelection200Response {
    return UpdatePalReauthEmrDocumentSelection200ResponseToJSONTyped(json, false);
}

export function UpdatePalReauthEmrDocumentSelection200ResponseToJSONTyped(value?: UpdatePalReauthEmrDocumentSelection200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': UpdatePalReauthEmrDocumentSelection200ResponseDataToJSON(value['data']),
    };
}

